export default "__VITE_ASSET__2o46qVC5__"